export default __webpack_public_path__ + "static/media/bindays-og.0a5772a4.jpg";